import { FC } from 'react';
import { SvgIcon, SxProps, Theme } from '@thirdspacelearning/library';

interface Props {
    sx?: SxProps<Theme>;
}

const PupilAvatarIcon: FC<Props> = ({ ...props }) => (
    <SvgIcon aria-labelledby="pupilAvatar" {...props} viewBox="0 0 96 95">
        <path
            d="M95.4067 47.4065C95.4067 73.5883 74.1821 94.8129 48.0002 94.8129C21.8183 94.8129 0.59375 73.5883 0.59375 47.4065C0.59375 21.2246 21.8183 0 48.0002 0C74.1821 0 95.4067 21.2246 95.4067 47.4065Z"
            fill="#EFEFEF"
        />
        <path
            d="M74.5869 86.7001L74.8842 45.965C74.9929 31.0657 63.0027 18.8993 48.1034 18.7905C33.2046 18.6818 21.0384 30.6713 20.929 45.5701L20.6314 86.1136C38.2255 98.3318 59.0452 96.8656 74.5869 86.7001Z"
            fill="#FFA726"
        />
        <path
            d="M45.3496 44.121C44.9187 41.0878 44.9391 39.2663 45.4824 35.7826"
            stroke="black"
            strokeWidth="2.53809"
            strokeLinecap="round"
        />
        <path
            d="M50.8599 44.3221C50.429 41.2889 50.4493 39.4674 50.9926 35.9837"
            stroke="black"
            strokeWidth="2.53809"
            strokeLinecap="round"
        />
        <path
            d="M33.4067 50.4145C35.253 48.3286 36.3823 47.415 39.0397 46.9487"
            stroke="black"
            strokeWidth="1.79872"
            strokeLinecap="round"
        />
        <path
            d="M56.498 47.3062C59.2402 47.7965 60.6082 48.285 62.3899 50.311"
            stroke="black"
            strokeWidth="1.79872"
            strokeLinecap="round"
        />
        <path
            d="M36.3762 62.5222L36.4717 49.4336C41.0033 51.4601 44.6559 52.3251 48.2459 52.2435C51.8162 52.1623 55.2449 51.1454 59.3153 49.5447L59.2198 62.6225C59.2152 63.254 58.85 63.8201 58.2914 64.0733C54.2735 65.8948 51.0778 66.8822 47.8809 66.9247C44.6947 66.9671 41.4109 66.0713 37.2258 63.949C36.7047 63.6848 36.3717 63.1323 36.3762 62.5222Z"
            fill="black"
            stroke="black"
            strokeWidth="1.79872"
            strokeLinecap="round"
        />
        <path
            d="M75.9955 51.2026L76.0571 42.6712C76.1689 27.1896 63.7092 14.5487 48.2277 14.4369V14.4369C32.7461 14.3251 20.1052 26.7847 19.9934 42.2663L19.9317 50.7977"
            stroke="black"
            strokeWidth="2.03135"
        />
        <path
            d="M14.0957 42.8829C14.1038 41.761 15.0198 40.8581 16.1416 40.8662L21.0168 40.9014L20.8935 57.9643L16.0184 57.9291C14.8966 57.921 13.9937 57.005 14.0018 55.8831L14.0957 42.8829Z"
            fill="black"
        />
        <path
            d="M81.8047 56.3728C81.7966 57.4947 80.8806 58.3975 79.7587 58.3894L74.8836 58.3542L75.0069 41.2914L79.882 41.3266C81.0038 41.3347 81.9067 42.2507 81.8986 43.3725L81.8047 56.3728Z"
            fill="black"
        />
        <path
            d="M19.9141 53.2418C26.3653 56.806 27.3637 57.7717 33.9007 57.4056M30.864 55.9617L33.9109 55.9837L33.8889 59.0307L31.0466 58.807L30.864 55.9617Z"
            stroke="black"
            strokeWidth="1.21881"
        />
    </SvgIcon>
);

export default PupilAvatarIcon;
